// src/Message/PurePanel.tsx
import { ConfigContext } from "antd/es/config-provider";
import classNames from "classnames";
import { Notice } from "rc-notification";
import * as React from "react";
import IconAlertCircleFilled from "../Svgs/IconAlertCircleFilled";
import IconCheckCircle from "../Svgs/IconCheckCircle";
import IconLoading from "../Svgs/IconLoading";
import IconWarning from "../Svgs/IconWarning";
import IconXCircle from "../Svgs/IconXCircle";
import useStyle from "./style";
var CUSTOM_MESSAGE_CLASS = "ant-message-custom";
var TypeIcon = {
  info: /* @__PURE__ */ React.createElement("span", { className: `${CUSTOM_MESSAGE_CLASS}-icon` }, IconAlertCircleFilled),
  success: /* @__PURE__ */ React.createElement("span", { className: `${CUSTOM_MESSAGE_CLASS}-icon` }, IconCheckCircle),
  error: /* @__PURE__ */ React.createElement("span", { className: `${CUSTOM_MESSAGE_CLASS}-icon` }, IconXCircle),
  warning: /* @__PURE__ */ React.createElement("span", { className: `${CUSTOM_MESSAGE_CLASS}-icon` }, IconWarning),
  loading: /* @__PURE__ */ React.createElement(
    "span",
    {
      className: `${CUSTOM_MESSAGE_CLASS}-icon ${CUSTOM_MESSAGE_CLASS}-icon-loading`
    },
    IconLoading
  )
};
function PureContent({
  prefixCls,
  type,
  icon,
  children
}) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(
        `${prefixCls}-custom-content`,
        `${prefixCls}-${type}`
      )
    },
    icon || TypeIcon[type],
    /* @__PURE__ */ React.createElement("span", null, children)
  );
}
function PurePanel(props) {
  const {
    prefixCls: staticPrefixCls,
    className,
    type,
    icon,
    content,
    ...restProps
  } = props;
  const { getPrefixCls } = React.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls("message");
  const [, hashId] = useStyle(prefixCls);
  return /* @__PURE__ */ React.createElement(
    Notice,
    {
      ...restProps,
      prefixCls,
      className: classNames(
        className,
        hashId,
        `${prefixCls}-notice-pure-panel`
      ),
      eventKey: "pure",
      duration: null,
      content: /* @__PURE__ */ React.createElement(PureContent, { prefixCls, type, icon }, content)
    }
  );
}
export {
  PureContent,
  TypeIcon,
  PurePanel as default
};
